import { Injectable, signal, computed } from '@angular/core';

export type Theme = 'dark' | 'light';

const THEME_KEY = 'user-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly theme = signal<Theme>(this.getSavedTheme());
  readonly isDark = computed(() => this.theme() === 'dark');

  constructor() {
    document.documentElement.setAttribute('data-theme', this.theme());
  }

  setTheme(theme: Theme): void {
    const html = document.documentElement;
    html.classList.add('theme-switching');
    this.theme.set(theme);
    html.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
    requestAnimationFrame(() => html.classList.remove('theme-switching'));
  }

  toggle(): void {
    this.setTheme(this.isDark() ? 'light' : 'dark');
  }

  private getSavedTheme(): Theme {
    const saved = localStorage.getItem(THEME_KEY);
    return saved === 'dark' ? 'dark' : 'light';
  }
}
